<template>
  <div class="ma-6">
    <h1>DashBoard</h1>
    <v-row>
      <v-col cols="12" lg="3" md="4" sm="6">
          <DashBoardBox title="CashIn" :value="databoard.cashin" colorclass="minosa" icon="mdi-cash"></DashBoardBox>
      </v-col>
      <v-col cols="12" lg="3" md="4" sm="6">
        <DashBoardBox title="CashOut" :value="databoard.cashin" colorclass="parfour" icon="mdi-cash"></DashBoardBox>
      </v-col>
      <v-col cols="12" lg="3" md="4" sm="6">
        <DashBoardBox title="Seller Request" :value="databoard.sellerreq" colorclass="disco" icon="mdi-account-tie"></DashBoardBox>
      </v-col>
      <v-col cols="12" lg="3" md="4" sm="6">
        <DashBoardBox title="Transactions" :value="databoard.jmltrx" colorclass="vivalocean" icon="mdi-transfer"></DashBoardBox>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" lg="4" md="6" sm="12">
        <div class="chart">
            <ChartTrx/>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="12">
        <div class="chart">
          <ChartOmset/>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="12">
        <div>
          <v-card>
            <v-toolbar elevation="0" dense>
              <v-toolbar-title>Rank</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-simple-table>
              <tbody>
                <tr v-for="item in rankseller" :key="item.memberid">
                  <td class="mt-2">#{{1}}</td>
                  <td class="mt-2" style="width: 100px;margin: 4px;padding: 10px;padding-left: 25px"><v-avatar><v-img :src="item.avatar"/></v-avatar></td>
                  <td class="mt-2">{{item.membername}}</td>
                  <td class="mt-2">{{item.omset}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DashBoardBox from '@/components/admin/DashBoardBox'
import ChartTrx from '@/components/admin/chart/ChartTrx'
import ChartOmset from '@/components/admin/chart/ChartOmset'
export default {
  name: 'AdminDashBoard',
  components: { ChartOmset, ChartTrx, DashBoardBox },
  data: () => ({
    databoard: {
      cashin: 1000000,
      cashout: 2000000,
      sellerreq: 5,
      jmltrx: 123210
    },
    rankseller: [
      {
        memberid: 1,
        membername: 'PulsaPro',
        avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1572776387/pulsa-pro-login-fb5dbea9c25bde7.png',
        omset: 3500
      },
      {
        memberid: 2,
        membername: 'WijayaKomunika',
        avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1584359176/logo-wikom-png5e6f67064cf14.png',
        omset: 3500
      },
      {
        memberid: 3,
        membername: 'Premium Payment',
        avatar: 'https://api.aviana.id:9780/images/500/34629ef0-b30c-11eb-8bd4-f768a161e14a.jpeg',
        omset: 3500
      },
      {
        memberid: 4,
        membername: 'RBk Payment',
        avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1609904478/whatsapp-image-2021-01-05-at-1502005ff5315c77be3.jpg',
        omset: 3500
      },
      {
        memberid: 5,
        membername: 'FA Payment',
        avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1592904573/icon-logo5ef1cb7b103e4.png',
        omset: 3500
      }
    ]
  })
}
</script>

<style scoped>
.chart {
  height: 500px !important;
}
</style>
